module.exports = __webpack_public_path__ + "bedroom.png?75c1548a7ff71fe35a72583394167606";